import "./App.css";
import Index from "./routes"; // ✅ Correct import
import ResponsiveAppBar from "./component/header";
import Footer from "./component/footer";
import FloatingSpeedDial from "./component/whatsapp"; // ✅ WhatsApp button
import { Box } from "@mui/material";
import DragBall from "./component/dragball";
import ScrollToTop from "./component/scrolltotop";

function App() {
  return (
    <Box className="App">
      <ResponsiveAppBar />
      <ScrollToTop />
      <Box className="content">
        <Index /> {/* ✅ Correct Component */}
      </Box>
      <Footer />
      <FloatingSpeedDial />
      {/* <DragBall /> */}
    </Box>
  );
}

export default App;
